// Add #radio-hide-show-container to the outer div
// Value is passed in, used to match the radio value
// Add .hide-show-section to the section you want to hide/show

/**
 * @param value
 * @returns {boolean}
 */
export const radioHideShow = (value) => {
  const container = document.querySelector('#radio-hide-show-container')
  if (container === null) {
    return false
  }
  const section = document.querySelector('#radio-hide-show-section')
  const radios = Array.from(container.querySelectorAll('input[type="radio"]'))
  section.classList.add('js-hidden')

  const showHideSection = (radio) => {
    if (+radio.value === +value) {
      section.classList.remove('js-hidden')
    } else {
      section.querySelector('input[type="text"]').value = ''
      section.classList.add('js-hidden')
    }
  }

  radios.forEach((radio) => {
    if (radio.checked) {
      showHideSection(radio)
    }
    radio.addEventListener('click', () => showHideSection(radio))
  })
}
